import { useMemo } from 'react'

export type SupportedLanguages = 'en' | 'fr'

export function useApplicationLanguages(): SupportedLanguages[] {
  return useMemo(() => ['en', 'fr'], [])
}
